var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProposedcash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 60 60",
    viewBox: "0 0 60 60",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4,15.5H38.6V12c0-2-1.7-3.7-3.7-3.7h-9.6c-2,0-3.7,1.7-3.7,3.7v3.5H8.7c-2,0-3.7,1.6-3.7,3.7V50c0,2,1.7,3.7,3.7,3.7 h42.6c2,0,3.7-1.7,3.7-3.7V19.1C55.1,17.1,53.4,15.5,51.4,15.5z M23.6,12c0-0.9,0.8-1.7,1.7-1.7h9.6c0.9,0,1.7,0.8,1.7,1.7v3.5h-13 V12z M7.1,19.1c0-0.9,0.8-1.7,1.7-1.7h42.6c0.9,0,1.7,0.7,1.7,1.7v8.6c0,1.8-1.5,3.3-3.3,3.3H32.6c0,0,0,0,0,0s0,0,0,0h-5 c0,0,0,0,0,0s0,0,0,0H10.4c-1.8,0-3.3-1.5-3.3-3.3V19.1z M28.5,33h3.1V37c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5V33z M51.4,51.7 H8.7c-0.9,0-1.7-0.8-1.7-1.7V31.8C8,32.6,9.1,33,10.4,33h16.1V37c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5V33h16.1 c1.3,0,2.4-0.5,3.3-1.2V50C53.1,50.9,52.3,51.7,51.4,51.7z",
    fill: "#470985",
    className: "color000 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposedcash);
export default __webpack_public_path__ + "static/media/proposedcash.635a75a0d424f64638787fd0c5e59e92.svg";
export { ForwardRef as ReactComponent };